/* Mega-menu image cards — switch the active category panel on hover (desktop).
   Delegated on document so it also covers the mobile drawer, which is cloned
   from a template at runtime. On mobile the tabs are hidden (CSS) and every
   panel is shown, so this switching is a no-op there. */
(function () {
  function activate(tab) {
    var wrap = tab.closest('.mega-cards');
    if (!wrap) return;

    var index = tab.getAttribute('data-mega-tab');

    wrap.querySelectorAll('.mega-cards__tab').forEach(function (el) {
      if (el === tab) {
        el.setAttribute('data-active', '');
      } else {
        el.removeAttribute('data-active');
      }
    });

    wrap.querySelectorAll('.mega-cards__panel').forEach(function (panel) {
      if (panel.getAttribute('data-mega-panel') === index) {
        panel.setAttribute('data-active', '');
      } else {
        panel.removeAttribute('data-active');
      }
    });
  }

  function handle(event) {
    if (!event.target || !event.target.closest) return;
    var tab = event.target.closest('.mega-cards__tab');
    if (tab) activate(tab);
  }

  function isMobile() {
    return window.matchMedia('(max-width: 767.98px)').matches;
  }

  /* Mobile drill-down: the category list (tabs) shows first; tapping a category
     opens its panel, the back button returns to the list. Desktop is untouched
     (it stays hover-driven and never gets the --mobile-panel-open class). */
  function handleClick(event) {
    if (!event.target || !event.target.closest) return;

    var back = event.target.closest('.mega-cards__mobile-back');
    if (back) {
      var backWrap = back.closest('.mega-cards');
      if (backWrap) backWrap.classList.remove('mega-cards--mobile-panel-open');
      event.preventDefault();
      return;
    }

    if (!isMobile()) return;

    var tab = event.target.closest('.mega-cards__tab');
    if (!tab) return;

    // Tabs without sub-levels render a real <a>; let it navigate normally.
    var link = event.target.closest('.mega-cards__tab-link');
    if (link && link.tagName === 'A') return;

    activate(tab);
    var wrap = tab.closest('.mega-cards');
    if (wrap) wrap.classList.add('mega-cards--mobile-panel-open');
    event.preventDefault();
  }

  // pointerover covers mouse + pen; focusin adds keyboard support.
  document.addEventListener('pointerover', handle);
  document.addEventListener('focusin', handle);
  document.addEventListener('click', handleClick);
})();
